// extracted by mini-css-extract-plugin
export default {"toolbar":"zMUBGb","button":"tTSPt8","goToDesktop":"M3hzxa"};